import InfoPanel from './InfoPanel-redux';

export default InfoPanel;
